import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const API = `${BASE}/api`;

const client = axios.create({ baseURL: API });

const TOKEN_KEY = "morphosy_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}
export function setToken(t) {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
}

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function formatError(detail) {
  if (detail == null) return "Si è verificato un errore. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function imageSourceFor(item) {
  if (!item) return null;
  if (item.imagePath) return `${API}/files/${item.imagePath}`;
  if (item.imageUrl) return item.imageUrl;
  return null;
}

export const api = {
  // public
  getStudio: () => client.get("/studio").then((r) => r.data),
  getStyles: () => client.get("/styles").then((r) => r.data),
  getArtists: () => client.get("/artists").then((r) => r.data),
  bookAppointment: (payload) => client.post("/appointments", payload).then((r) => r.data),
  aiConsultation: (payload) => client.post("/ai/consultation", payload).then((r) => r.data),
  aiMockup: (payload) => client.post("/ai/mockup", payload).then((r) => r.data),

  // auth
  register: (payload) => client.post("/auth/register", payload).then((r) => r.data),
  login: (payload) => client.post("/auth/login", payload).then((r) => r.data),
  adminLogin: (payload) => client.post("/auth/admin-login", payload).then((r) => r.data),
  me: () => client.get("/auth/me").then((r) => r.data),
  logout: () => client.post("/auth/logout").then((r) => r.data),

  // user
  myAppointments: () => client.get("/appointments/mine").then((r) => r.data),
  deleteAppointment: (id) => client.delete(`/appointments/${id}`).then((r) => r.data),

  // admin
  allAppointments: () => client.get("/appointments").then((r) => r.data),
  updateStudio: (payload) => client.put("/studio", payload).then((r) => r.data),
  saveStyle: ({ id, ...body }) =>
    client[id ? "put" : "post"](id ? `/styles/${id}` : "/styles", body).then((r) => r.data),
  deleteStyle: (id) => client.delete(`/styles/${id}`).then((r) => r.data),
  saveArtist: ({ id, ...body }) =>
    client[id ? "put" : "post"](id ? `/artists/${id}` : "/artists", body).then((r) => r.data),
  deleteArtist: (id) => client.delete(`/artists/${id}`).then((r) => r.data),
  uploadImage: (file) => {
    const fd = new FormData();
    fd.append("file", file);
    return client.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
  },
};

export default client;
